module.exports = __webpack_public_path__ + "img/device.5fcd20c3.svg";